<template>
    <div class="product-selector-container">
        <div class="product-selector-content">
            <h1 class="text-cod-gray md-title">Timbashield Product Selector</h1>
            <div class="wysiwyg">
                <p>Not quite sure what Timbashield product you need? With our Product Selector we’ll help you narrow down the type of products you’ll need.</p>
            </div>

            <button class="btn btn-tertiary" @click.prevent="next">
                <span class="btn-text">Start Product Selector</span>
                <figure class="btn-icon text-white">
                    <span class="inline-svg" style="padding-top: 100%">
                        <button-arrow />
                    </span>
                </figure>
            </button>
        </div>
    </div>
</template>
<script>
import selector from '~/data/selector'
export default {
    data: () => ({
        selector: selector
    }),
    methods: {
        next() {
            this.$store.commit('productSelector/ADD_STEP', selector[0])
            
            const footer = document.querySelector('.site-footer')
            footer.classList.add('site-footer--product-selector')
        },
    },
}
</script>
